/**
 * TYPE_USAGE payload nullable flag helpers.
 * IS_NULLABLE is first element (0|1 or "0"|"1"; some runtimes send strings).
 */

const NULLABLE_VALUES = [0, 1, '0', '1'] as const

/** Type guard: value is the nullable flag (0|1 or "0"|"1") from TYPE_USAGE payloads. */
export function isNullableFlag(value: unknown): value is 0 | 1 | '0' | '1' {
  return NULLABLE_VALUES.includes(value as (typeof NULLABLE_VALUES)[number])
}

/** Returns "?" when the TYPE_USAGE payload indicates nullable, else "". */
export function getNullableSuffix(payload: readonly unknown[]): string {
  const v = payload[0]
  return v === 1 || v === '1' ? '?' : ''
}

/** True if payload has valid structure (length <= 1 or first element is a nullable flag). */
export function isValidTypeUsagePayload(payload: unknown[]): boolean {
  if (payload.length <= 1) return true
  return isNullableFlag(payload[0])
}
